if (!customElements.get('sticky-cta')) {
  class StickyCta extends HTMLElement {
    connectedCallback() {
      this.hideElements = document.querySelectorAll('.hide-cta');
      if (!this.hideElements.length) return;

      this.showCta = false;
      this.shouldShowCta = false;
      this.desktopQuery = window.matchMedia('(min-width: 992px)');
      this.headerVisible = this.getHeaderVisible();

      this.onHeaderVisibilityChange = this.handleHeaderVisibilityChange.bind(this);
      this.onDesktopQueryChange = this.applyVisibility.bind(this);

      document.addEventListener('sticky-header:visibility-change', this.onHeaderVisibilityChange);
      this.desktopQuery.addEventListener('change', this.onDesktopQueryChange);

      this.observer = new IntersectionObserver(() => {
        const anyVisible = Array.from(this.hideElements).some((el) => {
          const r = el.getBoundingClientRect();
          return r.top < window.innerHeight && r.bottom > 0;
        });
        this.shouldShowCta = !anyVisible;
        this.applyVisibility();
      }, { threshold: 0, rootMargin: '0px' });

      this.hideElements.forEach((el) => this.observer.observe(el));
      this.applyVisibility();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      document.removeEventListener('sticky-header:visibility-change', this.onHeaderVisibilityChange);
      this.desktopQuery?.removeEventListener('change', this.onDesktopQueryChange);
    }

    handleHeaderVisibilityChange(e) {
      this.headerVisible = !!e.detail?.visible;
      this.applyVisibility();
    }

    getHeaderVisible() {
      const header = document.querySelector('sticky-header');
      const wrapper = header?.closest('.section-header') || header;
      return !!wrapper && !wrapper.classList.contains('-translate-y-full');
    }

    applyVisibility() {
      const hideForHeader = this.desktopQuery?.matches && this.headerVisible;
      this.toggle(this.shouldShowCta && !hideForHeader);
    }

    toggle(show) {
      if (show && !this.showCta) {
        this.showCta = true;
        this.classList.add('stuck');
      } else if (!show && this.showCta) {
        this.showCta = false;
        this.classList.remove('stuck');
      }
    }
  }
  customElements.define('sticky-cta', StickyCta);
}